var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { history } from '@idp/routables';
import { Canvas, Feedback } from '@idp/ui-components';
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import * as path from 'path';
import MainViewContainerWithStore from '../MainView/MainView.container';
import { CatalogDataType, RouteUrlTypes, AllowedBaseUrls } from '../MainView/MainView.container.props';
import * as styles from './Offer.container.scss';
import * as Loadable from 'react-loadable';
import { StateProvider } from '../../services/state-provider';
import PriceBarContainerWithStore from '../PriceBar/PriceBar.container';
import { FeedbackProvider } from '../../services/feedback-provider';
import { ThemeColor } from '@idp/ui-components/components/panels/Feedback/FeedbackProps';
import getTestId from '@idp/ui-components/utils';
import { getCookie, isWearableOnDevice } from '../../utils/UtilityFunctions';
import Cart from '../../components/Cart';
var Checkout = Loadable({
    loader: function () { return import(/* webpackChunkName: "Checkout" */ '../../components/Checkout'); },
    loading: function () { return (React.createElement("div", null, "Loading...")); },
});
var LoginContainer = Loadable({
    loader: function () { return import(/* webpackChunkName: "Login" */ '../../components/Login'); },
    loading: function () { return (React.createElement("div", null, "Loading...")); },
});
var fixedPriceBarOnPageLoad = true;
var Offer = /** @class */ (function (_super) {
    __extends(Offer, _super);
    function Offer(props) {
        var _this = _super.call(this, props) || this;
        _this.catalogs = new Map([
            [CatalogDataType.Wireless, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.Wireless })); }],
            [CatalogDataType.Bundle, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.Bundle })); }],
            [CatalogDataType.Offers, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.Offers })); }],
            [CatalogDataType.DTV, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.DTV })); }],
            [CatalogDataType.SNG, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.SNG })); }],
            [CatalogDataType.Broadband, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.Broadband })); }],
            [CatalogDataType.IPTV, function () { return (React.createElement(MainViewContainerWithStore, { bundleType: CatalogDataType.IPTV })); }],
        ]);
        _this.isEAPFlow = false;
        _this.isNativeIos = 'native' === getCookie('accessDomain') && (!!navigator.platform && /iPad|iPhone/.test(navigator.platform));
        _this.state = {
            fixedPriceBar: true,
        };
        fixedPriceBarOnPageLoad = true;
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.handelScroll = _this.handelScroll.bind(_this);
        return _this;
    }
    Offer.prototype.componentWillMount = function () {
        this.isEAPFlow = this.getEAPFlow();
    };
    Offer.prototype.componentDidMount = function () {
        window.document.addEventListener('scroll', this.handelScroll);
        var url = location.href;
        if (url.indexOf('/buy') > -1) {
            var arrURL = url.split('/buy');
            if (arrURL.length > 1) {
                var tempBaseUrl_1 = arrURL[1];
                if (tempBaseUrl_1.indexOf(RouteUrlTypes.DTVSPECIALOFFERS) <= -1) {
                    tempBaseUrl_1 = arrURL[1].toLowerCase();
                }
                var baseUrl = (tempBaseUrl_1.indexOf(RouteUrlTypes.DTVSPECIALOFFERS) > -1 ?
                    tempBaseUrl_1 :
                    AllowedBaseUrls.find(function (item) { return (tempBaseUrl_1.indexOf(item) > -1); }));
                if (baseUrl) {
                    this.stateManager.set('baseURL', { url: tempBaseUrl_1 });
                    if (url.indexOf(RouteUrlTypes.OFFERS) > -1 || url.indexOf(RouteUrlTypes.OFFERS.toUpperCase()) > -1) {
                        this.stateManager.set('baseURLDTV', { url: '/offers/select-plans' });
                        this.stateManager.set('baseURLWLS', { url: '/offers/changerateplan' });
                    }
                    else if (url.indexOf(RouteUrlTypes.DIRECTV) > -1 || url.indexOf(RouteUrlTypes.DIRECTV.toUpperCase()) > -1) {
                        this.stateManager.set('baseURLDTVS', { url: '/directv' });
                    }
                    else if (url.indexOf(RouteUrlTypes.WIRELESS) > -1 || url.indexOf(RouteUrlTypes.WIRELESS.toUpperCase()) > -1) {
                        if (url.indexOf('handoffToken') > -1 || url.indexOf('handofftoken') > -1) {
                            this.stateManager.set('handoffToken', { url: arrURL[1] });
                        }
                        this.stateManager.set('baseURLWLS', { url: '/wireless' });
                    }
                    else if (url.indexOf(RouteUrlTypes.BROADBAND) > -1 || url.indexOf(RouteUrlTypes.BROADBAND.toUpperCase()) > -1) {
                        this.stateManager.set('baseURLBB', { url: '/broadband' });
                    }
                    else if (url.indexOf(RouteUrlTypes.IPTV) > -1 || url.indexOf(RouteUrlTypes.IPTV.toUpperCase()) > -1) {
                        this.stateManager.set('baseURLIPTV', { url: '/iptv' });
                    }
                    else {
                        this.stateManager.set('baseURLDTV', { url: '/dtvnow/plans' });
                    }
                }
            }
        }
    };
    Offer.prototype.componentWillUnmount = function () {
        window.document.removeEventListener('scroll', this.handelScroll);
    };
    Offer.prototype.getEAPFlow = function () {
        var queryParam = location.href.split('?')[1];
        // handoffToken needs to check in session when coming back from login page for EAP onDevice Activation.
        var wrlssDtls = this.stateManager.get('appShell', 'wirelessDetails');
        var parmaArry = queryParam ? queryParam.split('&') : null;
        return ((parmaArry && parmaArry.filter(function (param) { return (param.includes('handoffToken=') || param.includes('flowtype=')); }).length > 0)
            || (wrlssDtls && !!wrlssDtls.handoffToken));
    };
    Offer.prototype.handelScroll = function () {
        var doc = document.documentElement;
        var priceBarElm = document.getElementById('feedbackFooter');
        var priceBarHeight = priceBarElm ? priceBarElm.clientHeight : -1;
        var isFixedPriceBar = doc.offsetHeight > (doc.scrollTop + doc.clientHeight + priceBarHeight);
        fixedPriceBarOnPageLoad = false;
        if (!isFixedPriceBar) {
            this.setState({ fixedPriceBar: false });
        }
        else if (!this.state.fixedPriceBar) {
            this.setState({ fixedPriceBar: true });
        }
    };
    Offer.prototype.getRedirection = function () {
        var query = history.location.search;
        if (query.indexOf('offerServiceType=dtvnow') > -1) {
            return (React.createElement(Redirect, { to: "/dtvnow" }));
        }
        else if (query.indexOf('offerServiceType=directv') > -1) {
            return (React.createElement(Redirect, { to: "/directv" }));
        }
        else if (query.indexOf('offerServiceType=wireless') > -1) {
            return (React.createElement(Redirect, { to: "/wireless" }));
        }
        else if (query.indexOf('offerServiceType=wirelessInterstitial') > -1) {
            return (React.createElement(Redirect, { to: "/wireless/upsell-offer-interstitial" }));
        }
        else if (query.indexOf('offerServiceType=broadband') > -1) {
            return (React.createElement(Redirect, { to: "/broadband" }));
        }
        else if (query.indexOf('offerServiceType=iptv') > -1) {
            return (React.createElement(Redirect, { to: "/iptv" }));
        }
        else {
            return (React.createElement(Redirect, { to: "/bundles" }));
        }
    };
    Offer.prototype.render = function () {
        var _a, _b;
        var url = ((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.match) === null || _b === void 0 ? void 0 : _b.url) || '';
        return (React.createElement(Canvas, null,
            React.createElement("div", { className: styles.canvasContent },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.CHECKOUT), component: Checkout }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.CART), component: Cart }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.LOGIN), component: LoginContainer }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.DIRECTV), render: this.catalogs.get(CatalogDataType.DTV) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.DTVNOW), render: this.catalogs.get(CatalogDataType.DTVNOW) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.WIRELESS), render: this.catalogs.get(CatalogDataType.Wireless) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.WIRELESSINTERSTITIAL), render: this.catalogs.get(CatalogDataType.WIRELESSINTERSTITIAL) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.BROADBAND), render: this.catalogs.get(CatalogDataType.Broadband) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.IPTV), render: this.catalogs.get(CatalogDataType.IPTV) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.OFFERS), render: this.catalogs.get(CatalogDataType.Offers) }),
                    React.createElement(Route, { path: path.join(url, RouteUrlTypes.BUNDLE), render: this.catalogs.get(CatalogDataType.Bundle) }),
                    React.createElement(Route, { path: path.join(url, '/'), exact: true, render: this.getRedirection }))),
            React.createElement("div", { id: "feedbackFooter" },
                React.createElement(PriceBarContainerWithStore, { className: fixedPriceBarOnPageLoad || this.state.fixedPriceBar ? (this.isNativeIos ? styles.bottom : '') : '' }),
                !this.isEAPFlow && !isWearableOnDevice() &&
                    React.createElement(Feedback, { data: { text: 'Feedback' }, events: { onClick: function (event) { return FeedbackProvider.openFeedback(event); } }, options: { theme: ThemeColor.LIGHT }, testId: getTestId('Common', 'Feedback') }))));
    };
    return Offer;
}(React.Component));
export default Offer;
//# sourceMappingURL=Offer.container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Offer/Offer.container.js
// module id = 1025
// module chunks = 8